import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { routerMiddleware, push } from 'react-router-redux';
import generateText from '../../pattern_utilities/generateText';
import Hashids from 'hashids';

import { tryToGetMyPatterns, tryToGetTeamPatterns } from '../actions.export.js'

var pf_config = require('../../pf_config.json');
var hashids = new Hashids('k100p');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// NEW PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const pmSetCurrentPattern = data => ({
  type: 'SET_CURRENT_PATTERN',
  data
})

export const requestNewPattern = data => ({
  type: 'REQUEST_NEW_PATTERN',
  data
})

export const receiveNewPatternSuccess = data => ({
  type: 'RECEIVE_NEW_PATTERN_SUCCESS',
  data
})

export const receiveNewPatternFail = data => ({
  type: 'RECEIVE_NEW_PATTERN_FAIL',
  data
})

export const tryToCreateNewPattern = data => (dispatch, getState) => {
  
  const { team, user } = getState();

  dispatch(requestNewPattern(data));

  var new_pattern = Object.assign({}, data);

  // for users
  var url = '/api/patterns';
  new_pattern.scope = user.id;

  var team_pattern = false;
  // override if team
  if(team.current && team.cache[team.current]){
    new_pattern.scope = team.cache[team.current].id;
    url = '/api/patterns/team/' + new_pattern.scope;
    team_pattern = true; 
  }

  delete new_pattern.history;
  
  return fetch(url, {
      method: 'post',
      body: JSON.stringify(new_pattern),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      json.text = generateText(json);
      json.saved = true;
      json.linkedToServer = true;
      dispatch(receiveNewPatternSuccess(json));
      dispatch(pmSetCurrentPattern({cacheID: json.id }));

      if(team_pattern){
        dispatch(push('/pat/' + hashids.encode(json.id)));
        dispatch(tryToGetTeamPatterns({
          id: team.current
        }));
      } else {
        dispatch(push('/pat/' + hashids.encode(json.id)));
        dispatch(tryToGetMyPatterns());
      }
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveNewPatternFail({errors:e, lastSubmit: data}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.POST.new-pattern.js